import { AccountAddress } from "@aptos-labs/ts-sdk";

export const validateEmail = (email: string) => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};

export function isValidAptosAddress(address: string): boolean {
  try {
    AccountAddress.fromString(address);
    return true;
  } catch {
    return false;
  }
}

// Strict variant — rejects short/zero-padded inputs that `fromString` would accept.
// Use for validating user-supplied or external-API addresses where mid-typing/
// ambiguous values must fail. See `project_aptos_address_parsing.md`.
export function isStrictAptosAddress(value: string): boolean {
  try {
    AccountAddress.fromStringStrict(value);
    return true;
  } catch {
    return false;
  }
}
